/* The scrollbar every scrolling card in this app draws, in one place.
 *
 * Chromium's default is FIFTEEN pixels wide, and every one of them comes off the flexible track
 * beside it: measured on the plan library's list before this rule existed, the row was 444px
 * against the specimen's 451 and the name column 173 against 180. Each canon reserves a gutter and
 * sizes its bar to match — the roster's own helmet says so in as many words ("szerokość paska musi
 * zgadzać się z rynną zarezerwowaną w nagłówku tabeli") — so the WIDTH is a per-surface value and
 * everything else about the bar is not.
 *
 * ── How to use it ────────────────────────────────────────────────────────────────────────────
 * Put the class on the scrolling element beside the surface's own, and state the size where the
 * canon's gutter is stated:
 *
 *   <div className={`${scrollbar.scrollbar} ${styles.scroller}`} />
 *   .scroller { --sb-size: 8px; --sb-radius: var(--radius-5px); }
 *
 * ── There is no default, and that is not an oversight ───────────────────────────────────────
 * `.scrollbar { --sb-size: 10px }` here and `--sb-size: 8px` in the surface's own file are two
 * single-class rules, so the one that wins is whichever the bundler emitted last — and that order
 * differs between the dev server and the production build. A default written as a declaration
 * would be a scrollbar that changes width when the app ships. A surface that states neither
 * property gets the platform's own bar, which is visible and wrong rather than subtly wrong.
 *
 * The RADIUS is the one exception, and for the opposite reason: a surface that states `--sb-size`
 * and forgets the radius gets an invalid `border-radius`, which computes to 0 and draws a square
 * thumb with nothing in the console to say so. A fallback INSIDE the `var()` is not a declaration —
 * nothing in a surface's own file can lose to it, so the chunk-order argument above does not reach
 * it. `--sb-size` gets no such fallback deliberately: a size fallback would change the bar a
 * surface that states neither property draws, which is the platform's own and visibly wrong rather
 * than subtly so.
 *
 * `scrollbar-gutter` is NOT set here. Reserving the gutter is a layout decision each surface makes,
 * and two of the four consumers do not make it. */

.scrollbar::-webkit-scrollbar {
  width: var(--sb-size);
  height: var(--sb-size);
}

.scrollbar::-webkit-scrollbar-thumb {
  background: var(--border-2);
  border-radius: var(--sb-radius, var(--radius-xs));
}

.scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
